import { getAppEnvironment } from "@/api/authenticate";
import vue from "../../../main";

const state = {
  loading: true,
  drawer: false,
  production: true
}

const mutations = {
  TOGGLE_LOADING: state => {
    state.loading = !state.loading;
  },
  STOP_LOADING: state => {
    state.loading = false;
  },
  START_LOADING: state => {
    state.loading = true;
  },
  SET_DRAWER: (state, payload) => {
    state.drawer = payload;
  },
  SET_PRODUCTION: (state, value) => {
    state.production = value;
    // if(!state.production){
    //   let theme = {
    //     primary: '#005538',
    //     secondary: '#f60',
    //     accent: '#9C27b0',
    //     info: '#00CAE3',
    //     success: '#52ae30'
    //   }
    //   vue.$vuetify.theme.themes.dark = theme;
    //   vue.$vuetify.theme.themes.light = theme;
    // }
  }
}

const actions = {
  toggleLoading({ commit }) {
    commit('TOGGLE_LOADING')
  },
  stopLoading({ commit }){
    commit('STOP_LOADING');
  },
  startLoading({ commit }){
    commit('START_LOADING');
  },
  // get app environment
  getAppEnvironment({ commit, state }) {
    return new Promise((resolve, reject) => {
      getAppEnvironment().then(data => {

        commit('SET_PRODUCTION', data);
        resolve(data);
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}